import {
  carsDetailsTranslation,
  CarsDetailsTranslation,
} from '@/assets/locales/views/cars/details/cars.details.translation.pl.ts';
import {
  carsListTranslation,
  CarsListTranslation,
} from '@/assets/locales/views/cars/list/cars.list.translation.pl.ts';

export type CarsViewTranslation = {
  details: CarsDetailsTranslation;
  list: CarsListTranslation;
};

export const carsViewTranslation: CarsViewTranslation = {
  details: carsDetailsTranslation,
  list: carsListTranslation,
};
